import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Column } from 'react-table';

import { useFilters } from '@store/hooks/filters';
import { useRatingsList } from '@store/hooks/ratings';

import { SORT_BY_PARAM } from '../../constants/filters';
import commonStyles from '../../styles/common.module.scss';

import { EmptyBlock } from './components/EmptyBlock';
import { Table } from './components/Table';
import styles from './ratings-table.module.scss';

export interface IRatingsNormalized {}

export enum TableColumnsNames {
  NUMBER = 'number',
  NAME = 'name',
  RATING = 'rating',
  REVIEWS_COUNT = 'reviewsCount',
  RESPONSE_COUNT = 'responseCount',
  SOLVED_PROBLEMS = 'solvedProblems',
  // RESPONSE_SPEED = 'responseSpeed',
}

export const TableSortColumnsMap = {
  [SORT_BY_PARAM.COMPLEX_CALCULATED_RATING_VALUE]: TableColumnsNames.RATING,
  [SORT_BY_PARAM.REVIEWS_COUNT]: TableColumnsNames.REVIEWS_COUNT,
  [SORT_BY_PARAM.ANSWERS_COUNT]: TableColumnsNames.RESPONSE_COUNT,
  [SORT_BY_PARAM.SOLVED_PROBLEMS]: TableColumnsNames.SOLVED_PROBLEMS,
  // [SORT_BY_PARAM.SPEED]: TableColumnsNames.RESPONSE_SPEED,
};

const columns: Column<IRatingsNormalized>[] = [
  {
    Header: '№',
    accessor: TableColumnsNames.NUMBER,
    disableSortBy: true,
  },
  {
    Header: 'Наименование',
    accessor: TableColumnsNames.NAME,
    disableSortBy: true,
  },
  {
    Header: 'Рейтинг',
    accessor: TableColumnsNames.RATING,
    sortDescFirst: true,
    sortType: 'number',
  },
  {
    Header: 'Отзывы',
    accessor: TableColumnsNames.REVIEWS_COUNT,
    sortDescFirst: true,
    sortType: 'number',
  },
  {
    Header: 'Ответы',
    accessor: TableColumnsNames.RESPONSE_COUNT,
    sortDescFirst: true,
    sortType: 'number',
  },
  {
    Header: () => (
      <>
        Решено
        <br />
        проблем
      </>
    ),
    accessor: TableColumnsNames.SOLVED_PROBLEMS,
    sortDescFirst: true,
    sortType: 'number',
  },
  // {
  //   Header: 'Скорость ответа',
  //   accessor: TableColumnsNames.RESPONSE_SPEED,
  //   disableSortBy: true,
  // },
];

export const RatingsTable = React.memo(() => {
  const [attemptNumber, setAttemptNumber] = useState<number>(0);

  const ratings = useRatingsList();
  const filters = useFilters();

  useEffect(() => {
    if (!ratings?.length) {
      setAttemptNumber((prev) => prev + 1);
    } else {
      setAttemptNumber(0);
    }
  }, [ratings?.length, filters]);

  return !ratings?.length ? (
    <EmptyBlock attempt={attemptNumber} />
  ) : (
    <div className={classNames(commonStyles.whiteRoundedBlock, styles.block)}>
      <Table data={ratings ?? []} columns={columns} />
    </div>
  );
});
